import { Widget, WIDGET_AREA } from "@gaming/srvg-classes-core";


export class AreaWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {
        options = options || {};
        options.selector = options.selector || '#areaWidget';
        super( options );

        this.name = 'widgetarea';
        this.widgetName = options.widgetName || WIDGET_AREA;
        this.widgetName = this.product + this.widgetName;

        this.widget = null;
        this.widgetOptions = {
            height: this.getContainerHeightWithUnit()
        };
        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addAreaWidget();
        super.handleDomInstantiated();
    }

    /**
     * add text widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addAreaWidget(selector?) {
        var that = this;
        selector = selector || this.selector;

        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

}
